import { useState } from 'react';
import { Accordion } from 'flowbite-react';
import cx from 'classnames';
import { NftReference } from 't2-graphql-types';
import { ArweaveTransactionLink } from './ArweaveTransactionLink';
import { NftTransactionLink } from './NftTransactionLink';

type TArticleTransactionsSectionProps = {
  arweaveId?: string;
  nftReference?: NftReference;
};

export const ArticleTransactionsSection = ({ arweaveId, nftReference }: TArticleTransactionsSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleIsOpen = () => setIsOpen((prevState) => !prevState);

  return (
    <Accordion collapseAll className="!rounded-[8px]">
      <Accordion.Panel>
        <Accordion.Title
          className={cx(
            'relative flex flex-row p-4 !text-sm text-t2-neutral-grey09 focus:ring-0 bg-transparent hover:bg-t2-neutral-grey03 !rounded-t-[7px]',
            {
              'hover:!rounded-[7px]': !isOpen,
            },
          )}
        >
          <div className="absolute inset-0 z-10 rounded-[8px]" onClick={toggleIsOpen} />
          <div className="flex">
            <div className="relative flex whitespace-nowrap w-fit">Transaction details</div>
          </div>
        </Accordion.Title>
        <Accordion.Content
          className={cx('!border-t-0 p-0 grid grid-rows-[0fr] transition-all duration-500', {
            '!grid-rows-[1fr]': isOpen,
          })}
        >
          <div className="overflow-hidden ">
            <div className="p-5 flex flex-col gap-5">
              {arweaveId && <ArweaveTransactionLink arweaveId={arweaveId} />}
              {nftReference?.chainId && nftReference.tokenId && nftReference.nftCollectionReference?.address && (
                <NftTransactionLink
                  contractAddress={nftReference.nftCollectionReference.address}
                  tokenId={nftReference.tokenId}
                  chainId={nftReference.chainId}
                />
              )}
            </div>
          </div>
        </Accordion.Content>
      </Accordion.Panel>
    </Accordion>
  );
};
